export enum MaxLength {
  S = 30,
  M = 400,
  L = 1000,
  XL = 1000,
  XXL = 4000,
  XXXL = 6000
}
